module.exports = __webpack_public_path__ + "media/fonts/CANDARALI-c284ca92c0a8111f27ccdd1d0af8c84d.TTF";